var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__row-group"},[_c(_setup.LinhaDeAditivoResumo,{attrs:{"dado":_setup.props?.dado,"aditivo":_setup.props?.aditivo},on:{"update:alteraAditivo":_setup.alteraAditivo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }